const objToSearchParam = (paramsObj) => {
    let query = "";
    for (let key in paramsObj) {
        if(paramsObj[key]) {
            const searchParam = `${key}=${paramsObj[key]}`;
            query += query === "" ? `?${searchParam}` : `&${searchParam}`;
        }
    }

    return query;
};

export default objToSearchParam;
